import { ComponentType, SVGProps } from 'react'
import { ReactComponent as UKFlagIcon } from '@svgs/flag/uk-flag.svg'
import { ReactComponent as USFlagIcon } from '@svgs/flag/us-flag.svg'
import { ReactComponent as EUFlagIcon } from '@svgs/flag/eu-flag.svg'
import { ReactComponent as AUFlagIcon } from '@svgs/flag/au-flag.svg'

export type StoreLocale = 'gb' | 'us' | 'eu'

export type CurrencyOption = {
  value: string
  label: string
  currency: string
  symbol: string
  store: 'GB' | 'US' | 'EU'
  locale: StoreLocale
  FlagIcon: ComponentType<SVGProps<SVGSVGElement>>
}

export const CURRENCY_OPTIONS: CurrencyOption[] = [
  {
    value: 'GB-GBP',
    label: 'United Kingdom',
    currency: 'GBP',
    symbol: '£',
    store: 'GB',
    locale: 'gb',
    FlagIcon: UKFlagIcon
  },
  {
    value: 'GB-AUD',
    label: 'Australia',
    currency: 'AUD',
    symbol: '$',
    store: 'GB',
    locale: 'gb',
    FlagIcon: AUFlagIcon
  },
  {
    value: 'US-USD',
    label: 'United States',
    currency: 'USD',
    symbol: '$',
    store: 'US',
    locale: 'us',
    FlagIcon: USFlagIcon
  },
  {
    value: 'EU-EUR',
    label: 'Europe',
    currency: 'EUR',
    symbol: '€',
    store: 'EU',
    locale: 'eu',
    FlagIcon: EUFlagIcon
  }
]
